import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-topics-summary',
  templateUrl: './topics-summary.component.html',
  styleUrls: ['./topics-summary.component.css']
})
export class TopicsSummaryComponent implements OnInit {

  topicCardList: any = [];
  allTopicsSummeryProgress: any;

  constructor(public selfLearnService:SelfLearnService, public router:Router) { }

  ngOnInit(): void {
    this.publishedVideoAndFlashcardCount();
  }

  publishedVideoAndFlashcardCount(){
    this.selfLearnService.publishedVideoAndFlashcardCount().subscribe((resp:any) => {
      console.log(resp.data);
      if(resp?.data){
        this.topicCardList = resp?.data;
        this.topicCardList.map((item:any) => {
          if(item.flashcardTaggedQuestionsCount > 0){
            item.publishedFlashcardCount = item.publishedFlashcardCount + 1;
          }
          return item;
        });
        this.getTopicSummaryProgress();
      }
    })
  }

  getTopicSummaryProgress(){
    this.selfLearnService.getTopicSummaryProgress().subscribe((resp:any) => {
      this.allTopicsSummeryProgress = resp?.data;
    })
  }

  navigateToChapterPage(){
    this.router.navigateByUrl('selfLearn-V2/chapter');
  }

}
